import gql from 'graphql-tag';

import { IdentityDetails } from '../../../../../../consumer/graphql/fragments/identity';
import {
  IdentityAlbumFolderTagBaseDetails,
  IdentityAlbumFolderUniformTagDetails,
} from '../../../../../../../graphql/fragments/identity';

export const IdentityForJerseyColors = gql`
  query IdentityForJerseyColors($id: RecordID!, $album_folder_id: RecordID!) {
    identity(id: $id) {
      id
      ...IdentityDetails
      album_folder_tags(
        slice: { limit: 999 }
        album_folder_id: $album_folder_id
      ) {
        records {
          id
          ...IdentityAlbumFolderTagBaseDetails
          ...IdentityAlbumFolderUniformTagDetails
        }
      }
      hierarchy_jersey_colors(
        hierarchy_item_id: $album_folder_id
        slice: { limit: 999 }
      ) {
        total
        records {
          id
          jersey_color
        }
      }
    }
  }
  ${IdentityDetails}
  ${IdentityAlbumFolderTagBaseDetails}
  ${IdentityAlbumFolderUniformTagDetails}
`;
